export default __webpack_public_path__ + "static/media/snowpards-critbase-partnership.e5d96202.jpg";